import React, { useContext } from "react";
import {
  Button,
  Card,
  CardHeader,
  Form,
  ListGroup,
  Modal,
} from "react-bootstrap";
import ApplicationContext from "../../context/ApplicationContext";
import { IReceipt } from "../../types/IReceipt";
import { IReceiptData } from "../../types/IReceiptData";
import { generateGUID } from "../../helpers/Helper";
import { ICardMachine } from "../../types/ICardMachine";
import { ICardMachineTransaction } from "../../types/ICardMachineTransaction";
import { Socket } from "dgram";

export interface ICardModalProps {
  close(): void;
  uuid: string;
  show: boolean;
}

export const CardModal: React.FC<ICardModalProps> = (
  props: ICardModalProps
): JSX.Element => {
  const context = useContext(ApplicationContext);
  const [printing, setPrinting] = React.useState(false);

  function closeModal() {
    props.close();
  }

  const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

  function getTotal() {
    let total = 0;
    context.Receipt.getRows().forEach((r) => {
      total += r.qty * r.price;
    });
    return total;
  }

  function onCardClick(card: ICardMachine) {
    const total = getTotal();
    context.Receipt.setPaymentType("Card");

    const transaction: ICardMachineTransaction = {
      uuid: generateGUID(),
      name: card.name,
      port: card.port,
      ip: card.ip,
      token: context.AuthenticatedUser.getToken(),
      total: total.toString(),
    };

    const jsonData = JSON.stringify(transaction);
    var encodedStringBtoA = btoa(jsonData);

    let url = "https://card.waepos.com/Default.aspx?id=" + 0;
    url += "&data=" + encodedStringBtoA;

    window.location.href = url;
  }

  const messageModal = (): JSX.Element => {
    return (
      <>
        <Modal
          show={props.show}
          onHide={() => closeModal()}
          size="xl"
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>Print</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <>
              <div style={{ float: "left" }}>
                {context.Configuration.getSettings()
                  .cardMachines.sort((a, b) =>
                    a.position > b.position ? 1 : -1
                  )
                  .map((c) => (
                    <div style={{ padding: 10, float: "left" }}>
                      <Button
                        variant="primary"
                        style={{
                          width: 200,
                          height: 150,
                          fontWeight: "bolder",
                          borderRadius: "10px",
                          fontSize: 16,
                        }}
                        onClick={() => onCardClick(c)}
                        key={c.id}
                      >
                        {c.name}
                      </Button>
                    </div>
                  ))}
              </div>
            </>
          </Modal.Body>
          <Modal.Footer className="modal-footer">
            <div className="mr-auto"></div>
            <div>
              <Button variant="success" size="lg" onClick={() => props.close()}>
                Complete & Print
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </>
    );
  };

  return (
    <>
      <>{messageModal()}</>
    </>
  );
};
